import React, { useState, useEffect } from 'react'
import * as components from '../../components'
import * as ReactBootstrap from 'react-bootstrap'
import { EditLoanerInventoryItem } from './EditLoanerInventoryItem'
import { DeleteLoanerInventoryItem } from './DeleteLoanerInventoryItem'
import { UnblockLoanerInventoryItem } from './UnblockLoanerInventroyItem'
import { TicketListPage } from '../Tickets'
import * as rest from '../../services'
import {useDispatch, useSelector} from 'react-redux'
import { showErrorToast } from '../../state/toasts'
import {DeviceWarrantyFormatter} from "../Tickets/DeviceWarrantyFormatter";

const getRowStyle = (item, rowIndex) => {
  const style = {}

  if (item.consumed) {
    style.borderLeft = '10px solid Orange'
    return style
  }
  if (item.blocked) {
    style.borderLeft = '10px solid Red'
    return style
  }

  style.borderLeft = '10px solid Green'
  return style
}

const AssignmentLogList = ({ inventoryItem }) => {
  const [assignmentLog, setAssignmentLog] = useState(null)
  const dispatch = useDispatch()
  const getAssignmentLog = () => {
    new rest.LoanerInventoryService(inventoryItem.url)
      .assignment_log()
      .then((response) => {
        setAssignmentLog(response)
      })
      .catch((errors) => {
        dispatch(
          showErrorToast('Could Not Load  Data.', JSON.stringify(errors))
        )
      })
  }
  useEffect(() => {
    getAssignmentLog()
  }, [])
  if (!assignmentLog) return <components.Loading />
  return <TicketListPage displayData={assignmentLog} />
}
export const LoanerInventoryDataGrid = ({
  results,
  descriptions,
  consignmentsTypes,
  page_size,
  current,
  count,
  onFilter,
  handleTableChange,
  children,
  hiddenRowKeys,
  onError,
  getData,
  onDelete,
}) => {
   const { user } = useSelector((state) => state.auth)
   const { role, is_superuser } = user
   const { rights } = useSelector((state) => state.userRights)
  const actionFormatter = (cell, row, rowIndex, formatExtraData) => {
     const hasManagerRights = rights?.filter(
         x=>x.has_manager_rights && x.organization===row.organization).length>0;

    const canDelete=(user && (role === 'SuperUser' ||
        is_superuser ||
        role==="Privileged"))

    return (
      <ReactBootstrap.Dropdown>
        <ReactBootstrap.Dropdown.Toggle
          variant="dark"
          size="sm"
        ></ReactBootstrap.Dropdown.Toggle>
        <ReactBootstrap.Dropdown.Menu>
          <EditLoanerInventoryItem
            title={'Edit Loaner Inventory Entry'}
            onSubmit={getData}
            onError={onError}
            loanerInventoryItem={row}
          />
          <components.Slider
            buttonType="dropdown"
            sliderWidth={'50vw'}
            header={<span>{components.ICONS.VIEW} Assignment Log</span>}
            title={
              <span className="">{components.ICONS.VIEW} Assignment Log</span>
            }
          >
            <AssignmentLogList inventoryItem={row} />
          </components.Slider>
          {canDelete && <DeleteLoanerInventoryItem
            onDelete={onDelete}
            onError={onError}
            loanerInventoryItem={row}
          />}
          {(canDelete || hasManagerRights) && <DeleteLoanerInventoryItem
            onDelete={onDelete}
            onError={onError}
            loanerInventoryItem={row}
            text={"Return"}
          />}
          <UnblockLoanerInventoryItem
            onUpdate={getData}
            onError={onError}
            loanerInventoryItem={row}
          />
        </ReactBootstrap.Dropdown.Menu>
      </ReactBootstrap.Dropdown>
    )
  }

  const columns = [
    {
      dataField: 'organization_code',
      searchFieldKey: 'organization',
      text: 'Organization',
      type: 'string',
      searchFieldType: 'text',
    },
    {
      dataField: 'part_number',
      text: 'Part Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'serial_number',
      text: 'Serial Number',
      type: 'string',
      formatter: DeviceWarrantyFormatter,
      searchFieldType: 'text',
    },
    {
      dataField: 'blocked',
      text: 'Blocked',

      formatter: components.BooleanFormatterWithCSS('blocked', 'text-left'),
    },
    {
      dataField: 'consumed',
      text: 'Consumed',

      formatter: components.BooleanFormatterWithCSS('consumed', 'text-left'),
    },

    {
      dataField: 'po_number',
      text: 'PO Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',

      hidden: true,
    },
    {
      dataField: 'awb_number',
      text: 'AWB Number',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',

      hidden: true,
    },
    {
      dataField: 'description',
      text: 'Description',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',

      hidden: true,
    },
            {
      dataField: 'created_by',
      text: 'Created By',
      type: 'string',
      formatter: components.CellTextFormatter,
      searchFieldType: 'text',

    },
      {
      dataField: 'is_cancelled',
      text: 'Returned',
      formatter: components.BooleanFormatterWithCSS('is_cancelled', 'text-left'),
    },

    {
      dataField: 'created_at',
      text: 'Created On',
      type: 'string',
      formatter: components.CellDateFormatter,
      searchFieldType: 'date',
    },
          {
      dataField: 'url',
      text: 'Change Log',
      formatter: components.ChangeLogFormatter,
    },
    {
      dataField: '',
      text: '',
      isDummyField: true,
      formatter: actionFormatter,
    },
  ]

  return (
    <ReactBootstrap.Card>
      <ReactBootstrap.Card.Header className="card-header bg-dark text-white">
        <ReactBootstrap.Row>
          <ReactBootstrap.Col xs={6}>Loaner Inventory</ReactBootstrap.Col>
          <ReactBootstrap.Col className="text-white text-end" xs={6}>
            <components.Slider
              size="sm"
              title={components.ICONS.SEARCH}
              sliderWidth={"20vw"}
              header={
                <span className="pr-3">
                  {components.ICONS.SEARCH}
                  <span className="pl-3"> Loaner Inventory</span>
                </span>
              }
            >
              <components.GenericSearchForm
                onFilter={onFilter}
                columns={columns}
              />
            </components.Slider>
            {children}
          </ReactBootstrap.Col>
        </ReactBootstrap.Row>
      </ReactBootstrap.Card.Header>
      <ReactBootstrap.Card.Body>
        <components.DataGrid
          rowStyle={getRowStyle}
          keyField="url"
          data={results || []}
          sizePerPage={page_size || 10}
          current={current || 1}
          columns={columns}
          page={current}
          count={count || 0}
          onTableChange={handleTableChange}
          hiddenRows={hiddenRowKeys}
        />
      </ReactBootstrap.Card.Body>
    </ReactBootstrap.Card>
  )
}
